import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Estudo } from '../estudo/estudo';
import { SituacaoEnum } from '../util/situacao.enum';
import { MatSnackBar } from '@angular/material';
import { Ocorrencia } from '../ocorrencia/ocorrencia';
import { OcorrenciaService } from '../ocorrencia/ocorrencia.service';
import { Pontuacao } from '../pontuacao/pontuacao';

@Component({
  selector: 'app-desclassificar-detail',
  templateUrl: './desclassificar-detail.component.html',
  styleUrls: ['desclassificar-detail.component.css']
})
export class DesclassificarDetailComponent implements OnInit {
  @Input()  estudo: Estudo;
  @Output()  desclassificarEmitido: EventEmitter<boolean> = new EventEmitter<boolean>();
  public lista: Ocorrencia[];
  public botaoSalvar: boolean;
  public isLoading: boolean;

  // construtor
  constructor(
    private ocorrenciaService: OcorrenciaService,
    public mensagem: MatSnackBar
  ) {}

  // ngOnInit é executado ao entrar na tela
  ngOnInit() {
    this.buscar();
  }


  // busca com filtro
  buscar() {
    this.isLoading = true;
    const pontuacao: Ocorrencia = new Ocorrencia();
    pontuacao.codigoEstudoSocioEconomico = this.estudo.id;
    this.ocorrenciaService.filtrar(pontuacao).subscribe(
      (results: Ocorrencia[]) => {
        if (results && results.length > 0) {
          this.lista = results;
          let existeOcorrenciaValida = false;
          results.forEach((ocorrencia: Ocorrencia) => {
            if (
              ocorrencia.dataEncerramento == null ||
              ocorrencia.dataEncerramento === undefined
            ) {
              existeOcorrenciaValida = true;
            }
          });

          if (!existeOcorrenciaValida) {
            this.carregaNovo();
          }
        } else {
          this.carregaNovo();
        }
        this.isLoading = false;
      },
      error => this.erro(error)
    );
  }

  carregaNovo() {
    const ocorrenciaNova: Ocorrencia = new Ocorrencia();
    ocorrenciaNova.codigoEstudoSocioEconomico = this.estudo.id;
    ocorrenciaNova.desclassificarEstudo = true;
    if (this.lista == null) {
      this.lista = new Array();
    }

    this.lista.push(ocorrenciaNova);
  }

  salvar(ocorrencia: Ocorrencia) {
    this.isLoading = true;
    this.botaoSalvar = false;
    this.ocorrenciaService.update(ocorrencia).subscribe(
      result => {
        this.isLoading = false;
        this.mensagem.open('Registro salvo com sucesso!', 'X', {
          duration: 5000
        });
        this.desclassificarEmitido.emit(true);
      },
      error => {
        this.erro(error);
        this.botaoSalvar = true;
      }
    );
  }

  encerrarDesclassificacao(ocorrencia: Ocorrencia) {
    this.isLoading = true;

    this.ocorrenciaService.encerrarOcorrencia(ocorrencia).subscribe(
      result => {
        this.isLoading = false;
        this.estudo.situacao = SituacaoEnum.EmAnalise;
        this.estudo.situacaoDenominacao = 'Em Análise';
        this.buscar();
        this.mensagem.open('Desclassificação encerrada com sucesso!', 'X', {
          duration: 5000
        });
      },
      error => {
        this.mensagem.open(error, 'X', { duration: 5000 });
        this.isLoading = false;
      }
    );
  }

  // mostra erros na tela
  erro(erro: string) {
    this.mensagem.open(erro, 'X', { duration: 5000 });
    this.isLoading = false;
  }

}
